module.exports = __webpack_public_path__ + "static/media/ranking-top-selected.2275ef32.svg";